import React, { useEffect, Fragment } from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import { connect } from 'react-redux';
import { getCurrentProfile } from '../../action/profile'
import spinner from '../layout/spinner';
import DashboardActions from './DashboardActions'
import Experience from './Experience';
import Education from './Education';

const Dashboard = ({ getCurrentProfile, auth: { user }, profile: { profile, loading } }) => {
            useEffect(() => {
                        getCurrentProfile()
            }, [])

            return loading && profile === null ? <spinner /> : <div>
                        <h1 className='large text-primary'>Dashboard</h1>
                        <p className='lead'>
                                    <i className='fas fa-user'></i>Welcome {user && user.name}
                        </p>
                        {profile !== null ? (<>
                                    <DashboardActions />
                                    <Experience experience={profile.experience} />
                                    <Education education={profile.education} />

                        </>) : (<>
                                    <p>You have not yet setup profile.Please add info</p>
                                    <Link to='/create-profile' className='btn btn-primary my-1'>Create Profile</Link>
                        </>)}
            </div>


}

Dashboard.propTypes = {
            getCurrentProfile: PropTypes.func.isRequired,
            auth: PropTypes.object.isRequired,
            profile: PropTypes.object.isRequired
}
const mapStateToProps = state => ({
            auth: state.auth,
            profile: state.profile
})
export default connect(mapStateToProps, { getCurrentProfile })(Dashboard);
